// gatsby-browser.js
import { ThemeProvider as UserPreferenceThemeProvider } from 'next-themes';
import { ThemeProvider } from 'styled-components';

import { CaptureParams } from '@/utils';
import { DARK_THEME } from '@/utils/theme/themes';

export const wrapRootElement = ({ element }) => {
  return (
    <CaptureParams>
      <ThemeProvider theme={DARK_THEME}>{element}</ThemeProvider>
    </CaptureParams>
  );
};

export const wrapPageElement = ({ element }) => {
  return (
    <UserPreferenceThemeProvider
      forcedTheme={
        element.type.forceTheme ||
        (element.type.supportsLightDark ? null : 'dark')
      }
      themes={['light', 'dark', 'pink']}>
      {element}
      {/* HubSpot script */}
      <script
        async
        defer
        id="hs-script-loader"
        src="//js-na2.hs-scripts.com/243040889.js"
        type="text/javascript"
      />
    </UserPreferenceThemeProvider>
  );
};
